<script setup lang="ts">
import type { PropertyGroupOption } from "@shopware-pwa/types";

export interface ProductVariantOptionProps {
  option?: PropertyGroupOption;
  optionButtonDefault: boolean;
}

const { option } = defineProps<ProductVariantOptionProps>();

const { product } = useProduct();
const isOptionNotCombinable = computed(
  (): boolean => option?.extensions?.combinable?.combinable === false,
);
const isOptionNotAvailable = computed(
  (): boolean => !product.value.available && isOptionSelected.value,
);
const isOptionSelected = computed(() => product.value?.optionIds?.includes(option.id));
</script>

<template>
  <button
    :aria-label="`option-${option.name}`"
    :class="[
      {
        'border-2 border-dark-blue': isOptionSelected,
        'border-beige/50': !isOptionSelected,
        'btn-size-xxs md:btn-size-xs': !optionButtonDefault,
        'text-medium-grey opacity-50': isOptionNotAvailable || isOptionNotCombinable,
      },
    ]"
    class="btn btn-ghost min-w-content relative flex-1 overflow-hidden"
  >
    <span :id="`${option.id}-choice-label`" data-testid="product-variant-text">
      {{ option.name }}
    </span>
  </button>
</template>
